import React, { useEffect, useState } from 'react';
import MenuMain from '../../MenuMain';
import { FormCursos } from '../../components/FormCursos';
import { AppFooter } from '../../AppFooter';

import api from '../../api/api';

export default function CadastrarCursosPage() {
  const [tipos, setTipos] = useState([]);

  const getTipoCursos = async () => {
    try {
      const respTipo = await api.get(`tipo-cursos`);

      const tiposFormatados = respTipo.data.map((tipo) => ({
        label: tipo.nome,
        value: tipo.id
      }));

      setTipos(tiposFormatados);
    } catch (error) {
      console.log('Erro ao buscar tipos de curso:', error);
    }
  };

  useEffect(() => {
    getTipoCursos();
  }, []);

  const defaultValues = {
    nome: '',
    obs: '',
    sigla: '',
    tipoId: '',
  };

  return (
    <div>
      <MenuMain>
        <FormCursos
          defaultValues={defaultValues}
          tipos={tipos} // Passa os tipos como prop separada
        />
      </MenuMain>
      <AppFooter />
    </div>
  );
}
